import axios from 'axios';
import { InventoryGetAllQuery, InventoryGetOneQuery } from '../../types';

class InventoryService {
  getAll = (props: any) => axios.get<InventoryGetAllQuery>('/inventories', props);

  getOne = ({ id, ...props }: any) => axios.get<InventoryGetOneQuery>(`/inventories/${id}`, props);

  add = (props: any) => axios.post('/inventories', props);

  update = ({ id, ...props }: any) => axios.patch(`/inventories/${id}`, props);

  itemUpdate = (props: any) => axios.patch(`/inventories/${props.id}/item-update`, props);

  complete = (props: any) =>
    axios.patch(`/inventories/${props.id}/complete`, { yardId: props.yardId });

  delete = (props: any) =>
    axios.delete(`/inventories/${props.id}`, { data: { yardId: props.yardId } });
}

export const inventoryService = new InventoryService();
